var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('svg',{staticClass:"icon",class:_vm.classes,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"fill":_vm.color?_vm.color:'#90939A',"xlink:href":'#'+_vm.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }